import { classNames } from "./Utils/classNames.ts";

export function SegmentedControl<Value extends string | number>({
  options,
  value,
  onChange,
}: {
  options: { value: Value; label: string }[];
  value: Value;
  onChange: (value: Value) => void;
}) {
  return (
    <div
      role={"group"}
      className={
        "inline-flex rounded-lg border border-slate-200 bg-white p-0.5 text-xs"
      }
    >
      {options.map((option) => (
        <button
          key={option.value}
          type={"button"}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
          className={classNames(
            "px-2.5 py-1 rounded-md whitespace-nowrap transition-colors",
            option.value === value
              ? "bg-slate-100 text-slate-800 font-semibold"
              : "text-slate-500 hover:text-slate-700",
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
